/** @format */

export enum FontFamily {
  openSans = "'Quicksand', 'Open Sans'",
}
